SupportThanksForContactingTemplate = require '../../../../thanks_for_contacting.html.mustache'
CommonBaseView = require "../../common/views/common_base_view"

class CallBackOptionSuccessView extends CommonBaseView
  template: SupportThanksForContactingTemplate

  render: (params = {}) ->
    @$el.append toHtml(@template, @toHash(params.waitTime), @I18nScope)

  toHash:(waitTime = 30)->
    phoneCallReceivemsg: I18n.translate('js.modules.support.call_me_back_phone_call_receive_msg', {display_wait_time: @getWaitTimeDisplayUnits(waitTime)})
    isCallMeBackFlow: true
    showCallBackThankYouMsg: true

  getWaitTimeDisplayUnits: (waitTime)->
    if (waitTime <= 20)
      displayWaitTime = 'half an hour'
    else if (waitTime <= 45)
      displayWaitTime = 'one hour'
    else if (waitTime <= 105)
      displayWaitTime = '2 hours'
    else
      displayWaitTime = 'shortly'

    displayWaitTime

module.exports = CallBackOptionSuccessView
